export const ASSET_TYPE_VALUES = [
  'audio',
  'document',
  'image',
  'pdf',
  'video'
] as const;
export type AssetType = (typeof ASSET_TYPE_VALUES)[number];
export type AssetOwnerCategory = 'author' | 'learner';
export type AssetFolder = 'author_assets' | 'learner_assets';
export interface AssetMetadata {
  /** Blob name, e.g. Yz_VQV-5r9-YJnjTepLoz. */
  assetkey: string;
  /** Full path within container, e.g. learner_assets/868013/fgMwyP3mCIFJhgjZSabbv. */
  assetpath?: string;
  owner: number;
  contentType: string;
  filename: string;
  size: number;
  hidden: boolean;
  dateCreated?: string;
}

//* Uploader's answer model
export interface AssetResponse {
  assetkey: string;
  owner: number;
  contentType: string;
}
